import type { ProspectFormValues } from '../../prospects/schema'
import { buildProspectPayload, mapProspectRow } from '../mappers/prospects'
import { ProspectsRepository } from '../repositories/prospects.repository'
import type { DatabaseRow, ProspectRow } from '../types/database.types'
import { unwrap } from './result'

export const ProspectService = {
  async list(): Promise<DatabaseRow[]> {
    return unwrap(await ProspectsRepository.listOverview())
  },

  async get(id: string): Promise<ProspectRow | null> {
    const row = unwrap(await ProspectsRepository.getById(id))
    return row ? mapProspectRow(row) : null
  },

  async create(form: ProspectFormValues, userId: string): Promise<ProspectRow> {
    return mapProspectRow(
      unwrap(
        await ProspectsRepository.create(
          buildProspectPayload(form, userId, 'insert'),
        ),
      ),
    )
  },

  async update(
    id: string,
    form: ProspectFormValues,
    userId: string,
  ): Promise<ProspectRow> {
    return mapProspectRow(
      unwrap(
        await ProspectsRepository.update(
          id,
          buildProspectPayload(form, userId, 'update'),
        ),
      ),
    )
  },

  async updateNextFollowUp(
    id: string,
    scheduledAt: string,
  ): Promise<ProspectRow> {
    return mapProspectRow(
      unwrap(
        await ProspectsRepository.update(
          id,
          buildProspectPayload({ next_follow_up_at: scheduledAt }),
        ),
      ),
    )
  },

  async listFormOptions(): Promise<{
    niches: DatabaseRow[]
    sources: DatabaseRow[]
  }> {
    const [niches, sources] = await Promise.all([
      ProspectsRepository.listNiches(),
      ProspectsRepository.listSources(),
    ])

    return { niches: unwrap(niches), sources: unwrap(sources) }
  },

  async contactChannels(id: string): Promise<DatabaseRow | null> {
    return unwrap(await ProspectsRepository.getContactChannels(id))
  },
}
